/**
 * Created by Slava on 17.10.2024
 */

const RaidStealPanelView = cc.Node.extend({
    ctor: function (village, player) {
        this._super();

        const styles = cleverapps.styles.RaidStealPanelView;
        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(styles);

        const stealPanelBg = cleverapps.UI.createScale9Sprite(bundles.village.frames.control_panel_bg);
        stealPanelBg.setContentSize(styles);
        stealPanelBg.setPosition(this.width / 2, this.height / 2);
        this.addChild(stealPanelBg);

        const youStoleText = cleverapps.UI.generateOnlyText("VillageRaidScene.stoleLabel", cleverapps.styles.FONTS.RAID_NAME_TEXT);
        const number = new TextWithIcon(`${aisensia.getNumberWithCommas(village.goldCollected)} ${TextWithIcon.ICONS_BY_NAME.hard}`, {
            font: cleverapps.styles.FONTS.RAID_GOLD_TEXT
        });

        const from = cleverapps.UI.generateOnlyText("VillageRaidScene.from", cleverapps.styles.FONTS.RAID_NAME_TEXT);
        const name = cleverapps.UI.generateOnlyText(player.name, cleverapps.styles.FONTS.RAID_STEAL_NAME_TEXT);

        const firstText = new cleverapps.Layout([youStoleText, number], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.text.wordMargin
        });

        const secondText = new cleverapps.Layout([from, name], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.text.wordMargin
        });
        secondText.setAnchorPoint(0, 0);

        const secondTextNode = new cc.Node();
        secondTextNode.setContentSize(firstText.getContentSize());
        secondTextNode.addChild(secondText);
        secondTextNode.setAnchorPoint(0.5, 0.5);

        const text = this.text = new cleverapps.Layout([firstText, secondTextNode], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.text.lineMargin
        });
        text.setAlignment(styles.text);
        this.addChild(text);

        this.setContentSize(stealPanelBg.getContentSize());
    },

    show: function () {
        this.runAction(new cc.Sequence(
            new cc.Hide(),
            new cc.MoveBy(0, 0, -this.height),
            new cc.PlaySound(bundles.main.urls.control_panel_bg),
            new cc.DelayTime(0.2),
            new cc.Show(),
            new cc.MoveBy(0.3, 0, this.height).easing(cc.easeOut(3))
        ));
    },

    hide: function () {
        this.runAction(new cc.Sequence(
            new cc.MoveBy(0.3, 0, -this.height).easing(cc.easeIn(3)),
            new cc.Hide()
        ));
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    RAID_STEAL_NAME_TEXT: {
        name: "nostroke",
        size: 36,
        color: new cc.Color(146, 129, 181),
        stroke: undefined,
        shadow: undefined
    },
    RAID_OK_BUTTON: {
        size: 60,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.styles.RaidStealPanelView = {
    width: 550,
    height: 215,

    button: {
        width: 175,
        height: 90,
        x: { align: "right", dx: -60 },
        y: { align: "center", dy: -20 }
    },

    text: {
        x: { align: "center", dx: -20 },
        y: { align: "center", dy: 20 },

        wordMargin: 20,
        lineMargin: 15
    }
};